import { useState, useRef, useEffect } from 'react';
import { Stage, Layer, Line, Text } from 'react-konva';
import React, { Component } from 'react';
import { render } from 'react-dom';
import Konva from 'konva';
import Button from '../Button';
import { addDrawing } from '../../core/services/api/patientDiagnosisService';
import { uploadSpecificFile } from '../../core/services/api';
import "./Drawingpad.scss"

const Drawingpad = ({ recordId, setDrawingSaved, drawingData, setDrawingData, setIsLoading, isReadOnly }: any) => {
  const [tool, setTool] = useState<any>('pen');
  const [lines, setLines] = useState<any>([]);
  const [strokeWidth, setStrokeWidth] = useState(5)
  const [colorPicked, setColorPicked] = useState("#000000")
  const [width, setWidth] = useState<any>()
  const isDrawing = useRef(false);
  const stageRef: any = useRef<any>(null);

  const handleExport = () => {
    // setIsLoading(true)
    const uri = stageRef?.current?.toDataURL()
    async function createFile() {
      let response = await fetch(uri);
      let data = await response.blob();
      let metadata = {
        type: "image/png"
      };
      let file = new File([data], "drawing.png", metadata);
      const formData = new FormData();
      formData.append('files', file);
      uploadSpecificFile(formData, true).then((res) => {
        addDrawing(recordId, res?.[0])
          .then((res) => {
            setDrawingSaved(true)
            let temp = { ...drawingData }
            temp["writings"] = res?.writings
            setDrawingData(temp)
            setIsLoading(false)
          })
          .catch((err) => {
            console.log(err)
            setIsLoading(false)
          })

      }).catch((err) => {
        console.log(err)
        setIsLoading(false)
      })

    }
    createFile();

  };

  const handlePointerDown = (e: any) => {
    isDrawing.current = true;
    const pos = e.target.getStage().getPointerPosition();
    setLines([...lines, { tool, colorPicked, points: [pos.x, pos.y] }]);
  };

  const handlePointerMove = (e: any) => {
    if (!isDrawing.current) {
      return;
    }
    const stage = e.target.getStage();
    const point = stage.getPointerPosition();
    let lastLine = lines[lines.length - 1];
    lastLine.points = lastLine.points.concat([point.x, point.y]);
    lines.splice(lines.length - 1, 1, lastLine);
    setLines([...lines]); // Use spread operator to trigger a re-render
  };

  const handlePointerUp = () => {
    isDrawing.current = false;
  };

  useEffect(() => {
    setTimeout(() => {
      const element = document.getElementById("drawing-pad-container")
      let width
      if (element) {
        width = element.clientWidth;
        setWidth(width)
      }
    }, 1000)
  })

  return (
    <div id="drawing-pad-container" className='drawing-pad-container'>
      {
        !isReadOnly && (
          <div className='toolbar cursor-pointer'>
            <div className='toolbar-item'>
              <img src="../../assets/images/pencil.jpg" style={{ border: tool === "pen" ? '1px solid blue' : '1px solid grey' }} onClick={() => {
                setTool("pen");
              }} />
            </div>
            <div className='toolbar-item'>
              <img src="../../assets/images/eraser.png" width="50" style={{ border: tool === "eraser" ? '1px solid blue' : '1px solid grey' }} onClick={() => {
                setTool("eraser");
              }} />
            </div>
            <div className='toolbar-item'>
              <button style={{ border: strokeWidth === 1 ? '1px solid blue' : '1px solid grey' }} onClick={() => setStrokeWidth((prev) => prev += 1)}>+</button>
            </div>
            <div className='toolbar-item'>
              <button style={{ border: strokeWidth === 5 ? '1px solid blue' : '1px solid grey' }} onClick={() => setStrokeWidth((prev) => prev -= 1)}>-</button>
            </div>
            <div className='toolbar-item'>
              <input style={{ border: colorPicked === "color" ? '1px solid blue' : '1px solid grey' }} type="color" value={colorPicked} onChange={(e) => {
                setColorPicked(String(e.target.value))
              }} />
            </div>
          </div>
        )
      }
      <Stage
        width={width - 40}
        height={window.innerHeight - 200}
        ref={stageRef}
        className="bg-light"
        onMouseDown={handlePointerDown}
        onMouseMove={handlePointerMove}
        onMouseUp={handlePointerUp}
        onTouchStart={handlePointerDown}
        onTouchMove={handlePointerMove}
        onTouchEnd={handlePointerUp}
      >
        {
          !isReadOnly && (
            <Layer>
              {lines.map((line: any, i: any) => (
                <Line
                  key={i}
                  points={line?.points}
                  stroke={line?.colorPicked}
                  strokeWidth={strokeWidth}
                  tension={0.5}
                  lineCap="round"
                  lineJoin="round"
                  globalCompositeOperation={
                    line?.tool === 'eraser' ? 'destination-out' : 'source-over'
                  }
                />
              ))}
            </Layer>
          )
        }
      </Stage>
      <div className="d-flex justify-content-center align-items-center">
        <Button text="Save Drawing" disabled={(lines.length > 0 ? false : true) || isReadOnly} onClick={handleExport} id="save-drawing" />
      </div>
    </div >
  );
};
export default Drawingpad;